import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import InstallPrompt from './InstallPrompt';
import { MenuIcon } from './Icons';

const routeBreadcrumbs = {
  '/': [{ label: 'Dashboard' }],
  '/campaigns': [{ label: 'Campaigns' }],
  '/campaigns/create': [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Create Campaign' }],
  '/proposals': [{ label: 'Proposals' }],
  '/payouts': [{ label: 'Payouts' }],
  '/leaderboard': [{ label: 'Leaderboard' }],
  '/hunters': [{ label: 'Hunters' }],
  '/profile': [{ label: 'Profile' }],
  '/users': [{ label: 'Admin' }, { label: 'Users' }],
  '/roles': [{ label: 'Admin' }, { label: 'Roles' }],
  '/tiers': [{ label: 'Admin' }, { label: 'Tiers' }],
  '/announcements': [{ label: 'Admin' }, { label: 'Announcements' }],
  '/testing-payment': [{ label: 'Admin' }, { label: 'Testing Payment' }],
  '/settings': [{ label: 'Admin' }, { label: 'Settings' }],
};

const getBreadcrumbs = (pathname) => {
  const exact = routeBreadcrumbs[pathname];
  if (exact) return exact;

  if (pathname.startsWith('/campaigns/edit/')) {
    return [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Edit Campaign' }];
  }
  if (pathname.startsWith('/campaigns/')) {
    return [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Campaign Detail' }];
  }
  if (pathname.startsWith('/hunters/')) {
    return [{ label: 'Hunters', href: '/hunters' }, { label: 'Hunter Detail' }];
  }
  if (pathname.startsWith('/proposals/')) {
    return [{ label: 'Proposals', href: '/proposals' }, { label: 'Proposal Detail' }];
  }
  return [{ label: 'Page' }];
};

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const breadcrumbs = getBreadcrumbs(location.pathname);

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex">
      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar — fixed left */}
      <div
        className={`fixed top-0 left-0 z-50 h-screen transition-transform duration-300 ${
          mobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
        }`}
      >
        <Sidebar
          collapsed={collapsed}
          onToggle={() => {
            setCollapsed(!collapsed);
            setMobileMenuOpen(false);
          }}
        />
      </div>

      {/* Content area */}
      <div
        className={`flex-1 flex flex-col min-h-screen min-w-0 transition-[margin] duration-300 ${
          collapsed ? 'md:ml-[80px]' : 'md:ml-[244px]'
        }`}
      >
        {/* Header — extra left padding on mobile so content clears the hamburger */}
        <div className="pt-4 pr-4 pb-0 pl-14 md:pl-4 sticky top-0 z-30">
          <Header breadcrumbs={breadcrumbs} />
        </div>

        {/* Main content */}
        <main className="flex-1 min-w-0 p-4 overflow-y-auto">
          {children}
        </main>
      </div>

      {/* Mobile hamburger */}
      <button
        onClick={() => setMobileMenuOpen(true)}
        className="fixed top-[22px] left-4 z-50 md:hidden bg-white text-[#3b3b3b] p-2 rounded-xl"
        style={{ boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)' }}
      >
        <MenuIcon />
      </button>

      <InstallPrompt />
    </div>
  );
};

export default Layout;
